import React from 'react';

/**
 * Inline notice when a mobile is already linked to an account
 * (same copy as the toast from showExistingAccountHint).
 */
export default function AccountHintBanner({ message, dark = false, className = '' }) {
  if (!message) return null;

  return (
    <div
      role="status"
      className={`mt-3 mb-1 flex items-start gap-2 rounded-lg border px-3 py-2 text-left ${
        dark
          ? 'border-sky-400/40 bg-sky-500/15 text-sky-100'
          : 'border-sky-200 bg-sky-50 text-sky-900'
      } ${className}`}
    >
      <span
        className={`mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full text-[10px] font-bold leading-none ${
          dark ? 'bg-sky-400 text-slate-900' : 'bg-sky-500 text-white'
        }`}
        aria-hidden
      >
        i
      </span>
      <p className="text-xs font-medium leading-snug">{message}</p>
    </div>
  );
}
